module.exports = __webpack_public_path__ + "files/8cc426f80355244a8189d171f999545a.png";